import React, { useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Eye, EyeOff } from "lucide-react";
import { useAuth, formatApiError } from "@/lib/auth";
import { toast } from "sonner";
import "./Login.css";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const submitting = useRef(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [visible, setVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (submitting.current) return;
    submitting.current = true;
    setLoading(true);
    setError("");
    try {
      await login(email, password);
      toast.success("Giriş başarılı");
      nav("/");
    } catch (err) {
      setError(err?.code === "ERR_NETWORK"
        ? "Sunucuya ulaşılamadı. Bağlantınızı kontrol edip tekrar deneyin."
        : err?.response?.status >= 500
          ? "Giriş şu anda tamamlanamıyor. Lütfen tekrar deneyin."
          : formatApiError(err));
    } finally {
      submitting.current = false;
      setLoading(false);
    }
  };
  return (
    <div className="tienti-signin" data-testid="login-page" lang="tr">
      <header className="signin-header">
        <img src="/brand/TIENTI_Primary_White.svg" alt="TIENTI" width="132" height="28"
          draggable="false" data-testid="tienti-wordmark" />
      </header>
      <main className="signin-main">
        <section className="signin-intro" aria-labelledby="product-title">
          <h1 id="product-title">Gayrimenkul Stok ve Satış Paneli</h1>
          <p>Projelerinizin stok, müşteri ve satış süreçlerini tek panelden yönetin.</p>
        </section>
        <section className="signin-panel" aria-labelledby="signin-title">
          <h2 id="signin-title">Giriş yap</h2>
          <p className="signin-description">Çalışma alanınıza erişin.</p>
          <form onSubmit={handleSubmit} data-testid="login-form" aria-busy={loading}>
            <div className="signin-field">
              <label htmlFor="login-email">E-posta</label>
              <input id="login-email" name="email" type="email" required value={email}
                onChange={(e) => setEmail(e.target.value)} placeholder="ornek@firma.com"
                data-testid="login-email" autoComplete="username" autoCapitalize="none"
                spellCheck={false} readOnly={loading} aria-describedby={error ? "login-error" : undefined} />
            </div>
            <div className="signin-field">
              <label htmlFor="login-password">Şifre</label>
              <div className="signin-password">
                <input id="login-password" name="password" type={visible ? "text" : "password"}
                  required value={password} onChange={(e) => setPassword(e.target.value)}
                  data-testid="login-password" autoComplete="current-password" readOnly={loading}
                  aria-describedby={error ? "login-error" : undefined} />
                <button type="button" className="signin-eye" onClick={() => setVisible(!visible)}
                  aria-label={visible ? "Şifreyi gizle" : "Şifreyi göster"}
                  title={visible ? "Şifreyi gizle" : "Şifreyi göster"} aria-controls="login-password">
                  {visible ? <EyeOff size={20} aria-hidden="true" /> : <Eye size={20} aria-hidden="true" />}
                </button>
              </div>
            </div>
            {error && <div id="login-error" className="signin-error" role="alert" data-testid="login-error">{error}</div>}
            <button type="submit" className="signin-submit" disabled={loading} data-testid="login-submit">
              {loading ? "Giriş yapılıyor…" : "Giriş yap"}
            </button>
          </form>
        </section>
      </main>
      <footer className="signin-footer">© {new Date().getFullYear()} TIENTI</footer>
    </div>
  );
}
